export default __webpack_public_path__ + "static/media/13.c48893d3.png";